import {Team} from "@/lib/interfaces/events";
import {PaginatorMeta} from "@/lib/interfaces/paginator";
import {apiFetch} from "@/lib/api";

type TeamsResponse = {
    data: Team[]
    meta: PaginatorMeta
}

export const getTeams = (sport: number|null = null, page: number = 1): Promise<TeamsResponse> => {
    const params = new URLSearchParams;
    params.set('page', page.toString());
    params.set('sort', 'name:asc');
    if (sport) {
        params.set('filterRelations[sport][id]', sport.toString());
    }
    return apiFetch(`teams?${params.toString()}`)
        .then(res => res.json())
        .then(json => {
            return {
                data: json.data,
                meta: json.meta
            }
        })
}